// import React, { Component } from 'react';
// import { BrowserRouter as Router, Route, withRouter } from 'react-router-dom';
// import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
// import { LoginCallback, Security, SecureRoute } from '@okta/okta-react';
// import SigninWidget from './components/auth/SigninWidget';
// import Home from './components/pages/Home';
// import SuppyChainRisk from './components/pages/SuppyChainRisk';
// import Details from './components/pages/Details';
// import Scaffold from './components/pages/Scaffold';
// import Dashboard from './components/pages/Dashboard';

// const oktaAuth = new OktaAuth({
//   issuer: `${process.env.REACT_APP_OKTA_ISSUER}`,
//   clientId: `${process.env.REACT_APP_OKTA_CLIENT_ID}`,
//   redirectUri: window.location.origin + '/login/callback'
// });

// class App extends Component {

//   constructor(props) {
//     super(props);
//     this.restoreOriginalUri = async (_oktaAuth, originalUri) => {
//       props.history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
//     };
//   }

//   render() {
//     return (
//       <Security oktaAuth={oktaAuth} restoreOriginalUri={this.restoreOriginalUri}>
//         <Route path="/" exact={true} component={SigninWidget}/>
//         <Route path="/login/callback" component={LoginCallback}/>
//         <Route path="/Home" component={Home}/>
//         <Route path="/supplyChain" component={SuppyChainRisk}/>
//         <Route path="/details" component={Details}/>
//         <Route path="/Scaffold" component={Scaffold}/>
//         <Route path="/Dashboard" component={Dashboard}/>



//       </Security>
//     );
//   }
// }

// const AppWithRouterAccess = withRouter(App);

// class RouterApp extends Component {
//   render() {
//     return (<Router><AppWithRouterAccess/></Router>);
//   }
// }

// export default RouterApp;


import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./components/auth/authConfig";
import SigninWidget from './components/auth/SigninWidget';
import Home from './components/pages/Home';
import SuppyChainRisk from './components/pages/SuppyChainRisk';
import Details from './components/pages/Details';
import Scaffold from './components/pages/Scaffold';
import Dashboard from './components/pages/Dashboard';
const App = () => {
  useEffect(() => {
    localStorage.setItem("historyListFlag", true);
    localStorage.setItem("historyCollapse", false);
  }, []);

  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <Switch>
          <Route exact path="/" component={SigninWidget} />

          <Route path="/Home" component={Home} />
          <Route path="/supplyChain" component={SuppyChainRisk} />
          <Route path="/details" component={Details} />
          <Route path="/Scaffold" component={Scaffold} />
          <Route path="/Dashboard" component={Dashboard} />

        </Switch>
      </Router>
    </MsalProvider>
  );
};

export default App;